import { render, staticRenderFns } from "./VehiclesIcon.vue?vue&type=template&id=2d18078e&scoped=true"
var script = {}
import style0 from "./VehiclesIcon.vue?vue&type=style&index=0&id=2d18078e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d18078e",
  null
  
)

export default component.exports